<template>
  <section class="listSkeleton">
    <v-skeleton-loader type="card-avatar"></v-skeleton-loader>
    <v-skeleton-loader type="card-avatar"></v-skeleton-loader>
  </section>
</template>
<script>
export default {
  name: 'ListSkeleton',
};
</script>
<style lang="scss">
.listSkeleton {
  padding: 10px 0;
  border-bottom: solid #ccc 1px;

  .v-skeleton-loader {
    max-width: 200px !important;
    &:nth-child(2) {
      max-width: 100px !important;
    }
  }
  .v-skeleton-loader__list-item-avatar {
    height: 25px;
  }
  .v-skeleton-loader__image {
    display: none;
  }
  .v-skeleton-loader__avatar {
    display: none;
    width: 25px;
    height: 25px;
  }
}
</style>
